export function seedAliasParts(path: string) {
  const match = /^\/catalog\/product-([1-9]\d*)\/?([?#].*)?$/.exec(path);
  if (!match || !Number.isSafeInteger(Number(match[1]))) return null;
  return { id: Number(match[1]), suffix: match[2] || '' };
}
